import { Button, Card, CardBody, Col, Modal, ModalBody, Row } from "reactstrap";
import premiumBoxImage from "../../assets/premium-box.png";
import {
  PremiumCheckIcon,
  PremiumIcon,
} from "../../assets/designedPickedIcons";
import { useState } from "react";
import CheckedInput from "../inputs/CheckedInput";
import { Link } from "react-router-dom";
import { RxCross2 } from "react-icons/rx";
import WhiteNavigator3 from "../navigators/WhiteNavigator3";

const CancelPremium = ({ modalOpen, setModalOpen, onCancel }) => {
  const [premiumTypeSelected, setPremiumTypeSelected] = useState(0);
  const premiumOptions = [
    { title: "1 Month", flowAt: 0 },
    { title: "3 Months", flowAt: 1 },
    { title: "6 Month", flowAt: 0 },
    { title: "1 Year", flowAt: 1 },
  ];
  return (
    <Modal
      className="modal-md-custom"
      centered
      fade={false}
      isOpen={modalOpen}
      toggle={() => setModalOpen((prev) => !prev)}
    >
      <ModalBody
        className="bg-white py-4 position-relative"
        style={{ borderRadius: "28.24px" }}
      >
        <Button
          onClick={() => setModalOpen(false)}
          className="bg-primary-blue d-flex align-items-center justify-content-center p-0 position-absolute full-rounded "
          style={{ height: 44, width: 44, left: 15, top: 15 }}
        >
          <RxCross2 strokeWidth={`1px`} size={18} />
        </Button>

        <Row className="g-0 justify-content-center">
          <Col md={11} xl={11} className="p-0">
            <>
              <h2 className="f-6 color-primary-blue text-center">
                Get Premium
              </h2>
              <p className="text-center color-primary-half-blue-3">
                Unlock all the power of this mobile tool and enjoy digital
                experience like never before!
              </p>
              <div className="mb-5">
                <WhiteNavigator3
                  items={premiumOptions}
                  flowAt={premiumTypeSelected}
                  setFlowAt={setPremiumTypeSelected}
                />
              </div>

              <Card className="premium-card mb-4">
                <CardBody className="px-5 ">
                  <div className="d-flex flex-wrap mb-3 align-items-center justify-content-between">
                    <h2 className="baloo-font f-6 text-white m-0">20 Chf</h2>
                    <PremiumIcon />
                  </div>
                  <h5 className="f-4 text-white mb-3 d-block ">
                  You have already subscribed premium package of 20 Chf /month
                  </h5>
                </CardBody>
              </Card>
              <div className="d-flex align-items-center gap-2 flex-wrap flex-md-nowrap mb-4">
                <div className="premium-desc-point">
                  <PremiumCheckIcon /> Use of discounts
                </div>
                <div className="premium-desc-point">
                  <PremiumCheckIcon /> Larger appereance on map
                </div>
                <div className="premium-desc-point">
                  <PremiumCheckIcon /> Use of commercials
                </div>
              </div>
              <div className="text-center mb-5">
                <img
                  src={premiumBoxImage}
                  height={200}
                  alt="premium-box-image"
                  className=" full-width object-fit-contain"
                />
              </div>

              <Button
                onClick={() => {
                  setModalOpen(false);
                  onCancel();
                }}
                className="standard-rounded-btn mb-4 btn-lg full-width"
              >
                Cancel Subscription
              </Button>
            </>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default CancelPremium;
